export enum EstatusSprintEnum {
    PENDIENTE = 'PENDIENTE',
    EN_PROCESO = 'EN_PROCESO',
    EN_PLANEACION = 'EN_PLANEACION',
    FINALIZADO = 'FINALIZADO'
}

export class EstatusSprint {
    public static obtenerEnum(valor: string): EstatusSprintEnum {
        switch (valor) {
            case 'PENDIENTE': return EstatusSprintEnum.PENDIENTE;
            case 'EN PROCESO': return EstatusSprintEnum.EN_PROCESO;
            case 'EN PLANEACIÓN': return EstatusSprintEnum.EN_PLANEACION;
            case 'FINALIZADO': return EstatusSprintEnum.FINALIZADO
            
        }
        return null;
    }

    public static eliminarGuion(estatus: string){
        return estatus.replace('_',' ')
    }
}